import React from 'react';

import {DrawerContentType} from '../WorkspaceDrawerContextProvider';
import {useSectionSettingOverrides} from './hooks/useSettingOverrides';
import {LinePlotSettings} from './runLinePlots/LinePlotSettings';
import {LinePlotSettingsContextProvider} from './runLinePlots/LinePlotSettingsContextProvider';
import {useSectionSettingsContext} from './SectionSettingsContextProvider';

export const LinePlotSectionSettings = ({
  displayedContentType,
  contentHeader,
}: {
  displayedContentType: DrawerContentType;
  contentHeader: React.ReactNode;
}) => {
  const {
    inheritedSettings,
    linePlot: sectionLinePlotSettings,
    trackSectionSettingChange,
    updateLinePlotSectionSettings,
  } = useSectionSettingsContext();

  const {clearSetting, settingOverrideCounts} = useSectionSettingOverrides();

  return (
    <LinePlotSettingsContextProvider
      clearSetting={clearSetting}
      displayLinePlotSettings={inheritedSettings.linePlot}
      linePlotSettings={sectionLinePlotSettings}
      settingOverrideCounts={settingOverrideCounts}
      settingLevel="section"
      trackLinePlotSetting={trackSectionSettingChange}
      updateLinePlotSettings={updateLinePlotSectionSettings}>
      <LinePlotSettings
        contentHeader={contentHeader}
        displayedContentType={displayedContentType}
      />
    </LinePlotSettingsContextProvider>
  );
};
